import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import ErrorInfo from 'components/Errors/ErrorInfo'
import ROUTES from 'utils/ROUTES'
import Maintenance from './Maintenances/Maintenance'

export const prodURL = 'https://espace-entreprises-rv.suez.fr'

interface Props {
  connected: boolean
}

const ErrorPage: React.FC<Props> = ({ connected }: Props) => {
  const { t } = useTranslation()

  return (
    <Switch>
      <Route exact path={ROUTES.DeniedAccess}>
        <ErrorInfo
          title={t('error.deniedAccess.title')}
          description={t('error.deniedAccess.description')}
          type="deniedAccess"
          connected={connected}
        />
      </Route>
      <Route exact path={ROUTES.TechnicalError}>
        <ErrorInfo
          title={t('error.technicalError.title')}
          description={t('error.technicalError.simpleDescription')}
          type="technicalError"
          connected={connected}
        />
      </Route>
      <Route exact path={ROUTES.MaintenanceError}>
        <Maintenance />
      </Route>
      <Route exact path={ROUTES.OldUrls}>
        <ErrorInfo
          title=""
          description={t('error.oldUrls.description')}
          type="notFound"
          chatbot={false}
          textButton={t('error.oldUrls.textButton')}
          externalLink={prodURL}
          connected={connected}
        />
      </Route>
      <Route>
        <ErrorInfo
          title={t('error.notFound.title')}
          description={t('error.notFound.description')}
          type="notFound"
          connected={connected}
        />
      </Route>
    </Switch>
  )
}

export default ErrorPage
